module.exports = __webpack_public_path__ + "static/media/wuerchahushan_mobile.3445e49a.webp";